import { render } from "./SwitchInput.vue?vue&type=template&id=ebac9d2e&scoped=true"
import script from "./SwitchInput.vue?vue&type=script&lang=js"
export * from "./SwitchInput.vue?vue&type=script&lang=js"

import "./SwitchInput.vue?vue&type=style&index=0&id=ebac9d2e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1697103798/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebac9d2e"]])

export default __exports__